import { motion } from "framer-motion";
import { Target, Sparkles, Smartphone, Maximize, Moon } from "lucide-react";

const useCases = [
  {
    icon: Target,
    title: "Gezielte Anwendung an kleinen Bereichen",
    text: "Wer bestimmte Körperstellen wie Gelenke, Nacken oder einzelne Muskelpartien fokussiert ansprechen möchte, ist mit kompakten Rotlichtgeräten oft gut beraten.",
  },
  {
    icon: Sparkles,
    title: "Gesicht und hautnahe Anwendung",
    text: "Für die Anwendung im Gesicht oder an empfindlicheren Hautstellen bieten sich Geräte an, die speziell für den Nahbereich konzipiert sind.",
  },
  {
    icon: Smartphone,
    title: "Flexibler Einsatz im Alltag",
    text: "Tragbare Geräte und Wearables können eine sinnvolle Option sein, wenn die Anwendung nicht an einen festen Ort gebunden sein soll.",
  },
  {
    icon: Maximize,
    title: "Großflächige Anwendung zuhause",
    text: "Für regelmäßige Ganzkörperanwendungen eignen sich größere Rotlichtpanels. Diese Geräte decken eine breitere Fläche ab.",
  },
  {
    icon: Moon,
    title: "Abendlicht und ruhigere Lichtumgebung",
    text: "Produkte mit warmem Lichtspektrum können dabei helfen, abends eine angenehmere Lichtatmosphäre zu schaffen.",
  },
];

const fadeUp = {
  hidden: { opacity: 0.4, y: 12 },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.06, duration: 0.3 },
  }),
};

const SelectionGuideSection = () => (
  <section id="auswahlhilfe" className="py-10 md:py-20">
    <div className="container">
      <h2 className="text-center font-display text-xl font-bold text-foreground sm:text-2xl md:text-3xl">
        Welches heilys Rotlichtgerät passt zu dir?
      </h2>
      <p className="mx-auto mt-2 max-w-2xl text-center text-sm text-muted-foreground md:mt-3 md:text-base">
        Die Wahl des passenden Rotlichtgeräts hängt vor allem vom geplanten Einsatzbereich ab. Die folgenden fünf typischen Nutzungssituationen sollen dir als erste Orientierung dienen.
      </p>

      <div className="mt-8 md:mt-10 grid gap-4 sm:gap-5 grid-cols-2 lg:grid-cols-3">
        {useCases.map((uc, i) => (
          <motion.article
            key={uc.title}
            custom={i}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            variants={fadeUp}
            className={`rounded-xl border border-border/50 bg-card p-3 sm:p-5 transition-all hover:border-primary/20 hover:shadow-lg hover:shadow-primary/5${i === useCases.length - 1 ? " col-span-2 lg:col-span-1" : ""}`}
          >
            <div className="inline-flex items-center justify-center rounded-lg bg-primary/10 p-1.5 sm:p-2">
              <uc.icon className="h-4 w-4 sm:h-5 sm:w-5 text-primary" aria-hidden="true" />
            </div>
            <h3 className="mt-2 sm:mt-3 font-display text-xs sm:text-sm font-semibold text-foreground leading-snug">
              {uc.title}
            </h3>
            <p className="mt-1 sm:mt-1.5 text-xs sm:text-sm leading-relaxed text-muted-foreground">
              {uc.text}
            </p>
          </motion.article>
        ))}
      </div>
    </div>
  </section>
);

export default SelectionGuideSection;
